import { reducer } from './messages-reducers'

export * from './messages-hooks'

export { reducer }
export default {
  reducer,
}
